import { useState } from "react";

import { LoadingButton } from "@mui/lab";

import "./styles.css";

const classesCF = {
  root: {
    margin: "16px",
  },
  button: {
    backgroundColor: "#ffffff",
    color: "#e1251b",
    border: "2px solid #e1251b",
    borderRadius: "25px",
    fontWeight: "bold",
    padding: "9px 0px",
    transition: "background-color 0.3s, color 0.3s",
    "&:hover": {
      backgroundColor: "#e1251b",
      fontWeight: "bold",
      color: "#ffffff",
    },
  },
  buttonHover: {
    backgroundColor: "#e1251b",
    color: "#ffffff",
  },
  buttonActive: {
    backgroundColor: "#e1251b",
    color: "#ffffff",
    border: "2px solid #e1251b",
  },
  buttonLoading: {
    backgroundColor: "#f4f4f4",
    border: "2px solid rgba(239, 239, 239, 0.3)",
    color: "#fff",
  },
  buttonLoadingHover: {
    backgroundColor: "#757575",
  },
};

const classesREY = {
  root: {
    margin: "16px",
  },
  button: {
    backgroundColor: "#ffffff",
    color: "#e1251b",
    border: "2px solid #e1251b",
    borderRadius: "25px",
    fontWeight: "bold",
    padding: "9px 0px",
    transition: "background-color 0.3s, color 0.3s",
  },
  buttonHover: {
    backgroundColor: "#e1251b",
    color: "#ffffff",
  },
  buttonActive: {
    backgroundColor: "#e1251b",
    color: "#ffffff",
    border: "2px solid #e1251b",
  },
  buttonLoading: {
    backgroundColor: "#f4f4f4",
    border: "2px solid rgba(239, 239, 239, 0.3)",
    color: "#fff",
  },
  buttonLoadingHover: {
    backgroundColor: "#757575",
  },
};

const classesTV = {
  root: {
    margin: "16px",
  },
  button: {
    backgroundColor: "#ffffff",
    color: "#ef732c",
    border: "2px solid #ef732c",
    borderRadius: "25px",
    fontWeight: "bold",
    padding: "9px 0px",
    transition: "background-color 0.3s, color 0.3s",
  },
  buttonHover: {
    backgroundColor: "#ef732c",
    color: "#ffffff",
  },
  buttonActive: {
    backgroundColor: "#ef732c",
    color: "#ffffff",
    border: "2px solid #ef732c",
  },
  buttonLoading: {
    backgroundColor: "#f4f4f4",
    border: "2px solid rgba(239, 239, 239, 0.3)",
    color: "#fff",
  },
  buttonLoadingHover: {
    backgroundColor: "#757575",
  },
};

const classesSRX = {
  root: {
    margin: "16px",
  },
  button: {
    backgroundColor: "#ffffff",
    color: "#e1251b",
    border: "2px solid #e1251b",
    borderRadius: "25px",
    fontWeight: "bold",
    padding: "9px 0px",
    transition: "background-color 0.3s, color 0.3s",
    "&:hover": {
      backgroundColor: "#e1251b",
      fontWeight: "bold",
      color: "#ffffff",
    },
  },
  buttonHover: {
    backgroundColor: "#e1251b",
    color: "#ffffff",
  },
  buttonActive: {
    backgroundColor: "#e1251b",
    color: "#ffffff",
    border: "2px solid #e1251b",
  },
  buttonLoading: {
    backgroundColor: "#f4f4f4",
    border: "2px solid rgba(239, 239, 239, 0.3)",
    color: "#fff",
  },
  buttonLoadingHover: {
    backgroundColor: "#757575",
  },
};

/**
 * SCSLoadingButton
 * @param titulo
 * @param size
 * @param loading
 * @param onClick
 * @returns {string}
 */
export const SCSLoadingButton = (props) => {
  /* const [estilos, setEstilos] = useState(3); */
  const [estilos, setEstilos] = useState(
    Number(localStorage.getItem("idGrupoStorage"))
  );

  return (
    <>
      {estilos === 1 ? (
        <LoadingButton
          {...props}
          /* className={`${classesCF.button} ${
            props.loading ? classesCF.buttonLoading : ""
          }`}
          classes={{
            loading: classesCF.buttonLoading,
          }} */
          sx={{
            ...classesCF.button,
            ...`${props.loading ? classesCF.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          type={`${props.type ? props.type : "submit"}`}
          /* type="submit" */
          size="small"
          loading={props.loading}
          loadingPosition="end"
          variant="contained"
          disabled={props.disabled}
          endIcon={props.endIcon}
        >
          {props.titulo}
        </LoadingButton>
      ) : estilos === 2 ? (
        <LoadingButton
          {...props}
          className={`${classesREY.button} ${
            props.loading ? classesREY.buttonLoading : ""
          }`}
          classes={{
            loading: classesREY.buttonLoading,
            /* active: classes.buttonActive, */
          }}
          sx={{
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          type={`${props.type ? props.type : "submit"}`}
          /* type="submit" */
          size="small"
          loading={props.loading}
          loadingPosition="end"
          variant="contained"
          disabled={props.disabled}
          endIcon={props.endIcon}
        >
          {props.titulo}{" "}
        </LoadingButton>
      ) : estilos === 3 ? (
        <LoadingButton
          {...props}
          /* className={`${classesTV.button} ${
            props.loading ? classesTV.buttonLoading : ""
          }`}
          classes={{
            loading: classesTV.buttonLoading,
          } */
          sx={{
            ...classesTV.button,
            ...`${props.loading ? classesTV.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          type={`${props.type ? props.type : "submit"}`}
          /* type="submit" */
          size="small"
          loading={props.loading}
          loadingPosition="end"
          variant="contained"
          disabled={props.disabled}
          endIcon={props.endIcon}
        >
          {props.titulo}{" "}
        </LoadingButton>
      ) : estilos === 4 ? (
        <LoadingButton
          {...props}
          /* className={`${classesSRX.button} ${
            props.loading ? classesSRX.buttonLoading : ""
          }`}
          classes={{
            loading: classesSRX.buttonLoading,
          }} */
          sx={{
            ...classesSRX.button,
            ...`${props.loading ? classesSRX.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          type={`${props.type ? props.type : "submit"}`}
          /* type="submit" */
          size="small"
          loading={props.loading}
          loadingPosition="end"
          variant="contained"
          disabled={props.disabled}
          endIcon={props.endIcon}
        >
          {props.titulo}{" "}
        </LoadingButton>
      ) : (
        <LoadingButton
          {...props}
          /* className={`${classesCF.button} ${
            props.loading ? classesCF.buttonLoading : ""
          }`}
          classes={{
            loading: classesCF.buttonLoading,
          }} */
          sx={{
            ...classesCF.button,
            ...`${props.loading ? classesCF.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          type={`${props.type ? props.type : "submit"}`}
          /* type="submit" */
          size="small"
          loading={props.loading}
          loadingPosition="end"
          variant="contained"
          disabled={props.disabled}
          endIcon={props.endIcon}
        >
          {props.titulo}{" "}
        </LoadingButton>
      )}
    </>
  );
};

/**
 * SCSLoadingButton
 * @param titulo
 * @param size
 * @param loading
 * @param onClick
 * @returns {string}
 */
export const SCSGenericButton = (props) => {
  const [estilos, setEstilos] = useState(
    Number(localStorage.getItem("idGrupoStorage"))
  );

  return (
    <>
      {estilos === 1 ? (
        <LoadingButton
          {...props}
          /* className={` ${
            props.active ? classesCF.buttonActive : classesCF.button
          }`}
          classes={{
            active: classesCF.buttonActive,
          }} */
          sx={{
            ...classesCF.button,
            ...`${props.loading ? classesCF.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          size="small"
          variant="contained"
          onClick={props.onClick}
          loading={props.loading}
          loadingPosition="end"
          disabled={props.disabled}
          hidden={props.hidden}
          endIcon={props.endIcon}
        >
          {props.titulo}
        </LoadingButton>
      ) : estilos === 2 ? (
        <LoadingButton
          {...props}
          /* className={` ${
            props.active ? classesREY.buttonActive : classesREY.button
          }`}
          classes={{
            active: classesREY.buttonActive,
          }} */
          sx={{
            ...classesCF.button,
            ...`${props.loading ? classesCF.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          size="small"
          variant="contained"
          onClick={props.onClick}
          loading={props.loading}
          loadingPosition="end"
          disabled={props.disabled}
          hidden={props.hidden}
          endIcon={props.endIcon}
        >
          {props.titulo}
        </LoadingButton>
      ) : estilos === 3 ? (
        <LoadingButton
          {...props}
          /* className={` ${
            props.active ? classesTV.buttonActive : classesTV.button
          }`}
          classes={{
            active: classesTV.buttonActive,
          }} */
          sx={{
            ...classesCF.button,
            ...`${props.loading ? classesCF.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          size="small"
          variant="contained"
          onClick={props.onClick}
          loading={props.loading}
          loadingPosition="end"
          disabled={props.disabled}
          hidden={props.hidden}
          endIcon={props.endIcon}
        >
          {props.titulo}
        </LoadingButton>
      ) : estilos === 4 ? (
        <LoadingButton
          {...props}
          /* className={` ${
            props.active ? classesSRX.buttonActive : classesSRX.button
          }`}
          classes={{
            active: classesSRX.buttonActive,
          }} */
          sx={{
            ...classesCF.button,
            ...`${props.loading ? classesCF.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          size="small"
          variant="contained"
          onClick={props.onClick}
          loading={props.loading}
          loadingPosition="end"
          disabled={props.disabled}
          hidden={props.hidden}
          endIcon={props.endIcon}
        >
          {props.titulo}
        </LoadingButton>
      ) : (
        <LoadingButton
          {...props}
          /* className={` ${
            props.active ? classesSRX.buttonActive : classesSRX.button
          }`}
          classes={{
            active: classesSRX.buttonActive,
          }} */
          sx={{
            ...classesCF.button,
            ...`${props.loading ? classesCF.buttonLoading : ""}`,
            minWidth: props.size ? `${props.size}%` : "35%",
            minHeight: "5%",
          }}
          size="small"
          variant="contained"
          onClick={props.onClick}
          loading={props.loading}
          loadingPosition="end"
          disabled={props.disabled}
          hidden={props.hidden}
          endIcon={props.endIcon}
        >
          {props.titulo}
        </LoadingButton>
      )}
    </>
  );
};
